// extracted by mini-css-extract-plugin
export default {"container":"lq-z","heading":"mq-z","text":"nq-z","info":"oq-z","link":"pq-z","fullMaxWidth":"qq-z"};